/**
 * Converts an uppercase underscore string (e.g. "IN_PROGRESS")
 * into a human-friendly format (e.g. "In progress").
 */
export const formatEnumText = (text = "") => {
  if (!text) return "";
  return text
    .toLowerCase()               // "in_progress"
    .split("_")                  // ["in", "progress"]
    .map(word => 
      word.charAt(0).toUpperCase() + word.slice(1) // Capitalize each word
    )
    .join(" ");                  // "In Progress"
};

export default formatEnumText;